<template>
  <td
    class="edit-cell text-left"
    :class="{
      'selected-cell': isSelect,
      'bg-white': isEdit,
      'drag-top': toTopDrag,
      'drag-bottom': toBottomDrag,
      'edit-cell-hover': editable
      }
    "
    @dblclick="editCell(true)"
    colspan="2"
    @dragover.prevent="dragover($event)"
    @dragleave.prevent="dragleave($event)"
    @click.right="rightClick()"
    @contextmenu.capture.prevent
  >
    <PricingEditBox
      v-if="showMenu"
      class="editbox"
      :item="component"
      @close="showMenu=false"
      @indent="columnActions('indentComponent')"
      @outdent="columnActions('outdentComponent')"
      @enable="columnActions('disableComponent')"
      @hide="columnActions('hideComponent')"
      @delete="columnActions('deleteComponent')"
      @duplicate="columnActions('duplicateComponent')"
      @clear="columnActions('clearComponent')"
      from="component"
    >
    </PricingEditBox>

    <div class="span-wrapper" >
      <span class="value-span" :class="{'disabled-row': component.disabled, 'pl-0': isEdit}">
        {{ spanValue }}
        <textarea
          v-model="form.value"
          @input="handleInput"
          @focus="handleFocus"
          @blur="handleBlur"
          @keydown="handleKeydown"
          :class="{
            'editing-cell': isEdit
          }"
          rows="1"
          ref="textarea"
          :disabled="!editable"
        ></textarea>
      </span>
    </div>
    <div class="hidden-icon-wrapper">
      <img
        src="/images/ShowColumn.svg"
        class="hidden-row-above"
        v-if="showColumnIcon"
        @click="unhideComponent()"
      >
    </div>
    <img
      src="/images/ShowColumn.svg"
      class="hidden-row-bottom"
      v-if="showColumnBottomIcon"
      @click="unhideBottomComponent()"
    >
    <img
      @dragstart="dragstart($event)"
      @dragend="dragend($event)"
      src="/images/Grab.svg"
      class="move-module"
      v-if="!isEdit"
    />
    <img
      v-if="!isEdit"
      src="/images/More-Vertical.svg"
      class="delete-module"
      @click="showMenu=true"
    />
  </td>
</template>

<script>
import { mapGetters } from 'vuex';
import Helpers from '../../../../util/helper';
import PricingEditBox from './PricingEditBox'

export default {
  name: 'PricingSheetComNameCell',
  data () {
    return {
      isEdit: false,
      isSelect: false,
      form: {
        value: ''
      },
      pastedValues: [],
      showMenu: false,
      toTopDrag: false,
      toBottomDrag: false
    };
  },
  components: {
    PricingEditBox
  },
  props: {
    component: {
      required: true
    },
    moduleKey: {
      type: Number,
      required: true
    },
    comKey: {
      type: Number,
      required: true
    },
    isDragEnded: {
      defalut: false
    },
    dragStartedKey: {
      defalut: {}
    }
  },
  methods: {
    rightClick() {
      if (this.editable) {
        this.showMenu = true
      }
    },
    handleInput(e) {
      if (!this.isEdit) {
        if (e.inputType === 'historyUndo' || e.inputType === 'historyRedo') {
          return;
        }
        this.editCell(false)
      }
      const values = e.target.value
        .split(/\r?\n/g)
        .filter(v => v !== '')
      if (values.length == 1) {
        this.isPaste = false
        this.form.value = values[0]
      } else if (values.length > 1) {
        this.isPaste = true
        this.pastedValues = e.target.value.split(/\r?\n/g)
        this.pasteBottomCells()
      }
    },
    handleKeydown(e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        this.changeName('')
      } else if (e.key === 'Escape') {
        if (this.isEdit) {
          this.cleanEdit()
        }
      } else if (e.key === 'Enter') {
        if (this.isEdit) {
          this.changeName(this.form.value)
          this.cleanEdit()
          this.$store.dispatch('keyDownCell');
        }
      }
    },
    async handleBlur(e) {},
    async pasteBottomCells() {
      this.isSelect = false;
      this.isPaste = false;
      this.cleanEdit()
      this.$store.dispatch('pasteComponentName',  {
        projectid: this.$route.params.projectid,
        moduleKey: this.moduleKey,
        comKey: this.comKey,
        pastedValues: this.pastedValues
      })
    },
    handleEditBoxBlur() {
      this.showMenu = false;
    },
    handleFocus(e) {
      if (!this.isSelect) {
        this.$store.dispatch('updateSelectedCell', {
          moduleKey: this.moduleKey,
          comKey: this.comKey
        })
      }
    },
    editCell(updateEditing) {
      if (!this.editable) {
        return
      }
      if (!this.isEdit) {
        this.isSelect = true;
        this.isEdit = true;
        this.form.value = this.component.name
        if (updateEditing) {
          this.$store.dispatch('updateEditingCell', {
            moduleKey: this.moduleKey,
            comKey: this.comKey
          })
        }
      }
    },
    columnActions(actions) {
      this.$store.dispatch(actions, {
        projectid: this.$route.params.projectid,
        moduleindex: this.moduleKey,
        componentid: this.comKey
      })
      this.showMenu = false
    },
    unhideComponent () {
      const componentsToUnhide = []
      componentsToUnhide.push(this.comKey - 1)
      for (let i = this.comKey - 1; i < this.components.length; i++) {
        if (this.components[i].hidden && componentsToUnhide.indexOf(i) == -1) {
          componentsToUnhide.push(i)
        } else {
          break
        }
      }
      for (let i = this.comKey - 1; i >= 0; i--) {
        if (this.components[i].hidden && componentsToUnhide.indexOf(i) == -1) {
          componentsToUnhide.push(i)
        } else {
          break
        }
      }
      this.$store.dispatch('unhideComponents', {
        projectid: this.$route.params.projectid,
        moduleindex: this.moduleKey,
        componentsToUnhide: componentsToUnhide
      })
      this.showMenu = false
    },
    unhideBottomComponent () {
      const componentsToUnhide = []
      for (let i = this.comKey + 1; i < this.components.length; i++) {
        if (this.components[i].hidden && componentsToUnhide.indexOf(i) == -1) {
          componentsToUnhide.push(i)
        } else {
          break
        }
      }
      this.$store.dispatch('unhideComponents', {
        projectid: this.$route.params.projectid,
        moduleindex: this.moduleKey,
        componentsToUnhide: componentsToUnhide
      })
      this.showMenu = false
    },
    dragover(e) {
      if (this.dragStartedKey.comKey > this.comKey) {
        this.toTopDrag = true
      }
      if (this.dragStartedKey.comKey < this.comKey) {
        this.toBottomDrag = true
      }
      this.$emit('dragOvered', this.comKey)
    },
    dragleave(e) {
      this.toTopDrag = false
      this.toBottomDrag = false
    },
    dragstart(e) {
      this.$emit('dragStarted', this.comKey)
    },
    dragend(e) {
      this.$emit('dragEnded', this.comKey)
    },
    changeName(value) {
      this.$store.dispatch('changeComponentName',  {
        projectid: this.$route.params.projectid,
        key3: this.moduleKey,
        component: 'title',
        key2: this.comKey,
        value
      })
    },
    cleanEdit(value) {
      this.isEdit = false
      this.form.value = ''
      this.$store.dispatch('updateEditingCell', null)
    }
  },
  computed: {
    ...mapGetters(['currentProjectModules', 'selectedCell', 'userRole']),
    showColumnIcon() {
      if (this.comKey) {
        return this.components[this.comKey - 1].hidden
      }
      return false
    },
    showColumnBottomIcon() {
      if (this.comKey == this.components.length - 1) {
        return false
      }
      return this.components.slice(this.comKey + 1).every(c => c.hidden)
    },
    components() {
      return this.currentProjectModules[this.moduleKey].components
    },
    spanValue() {
      let value = ''
      if (this.isEdit) {
        return value
      }
      for (let i = 0; i < this.component.indented; i++) {
        value += '\xa0\xa0\xa0\xa0\xa0\xa0\xa0'
      }
      return value + this.component.name
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  watch: {
    isDragEnded(value) {
      if (value) {
        this.toTopDrag = false
        this.toBottomDrag = false
      }
    },
    selectedCell(data) {
      this.isSelect = data.moduleKey === this.moduleKey &&
        data.comKey === this.comKey &&
        data.cellKey === undefined &&
        data.prefix === undefined
      if (!this.isSelect) {
        if (!this.isPaste && this.isEdit) {
          this.changeName(this.form.value)
        }
        this.cleanEdit()
      } else {
        this.$refs.textarea.focus()
      }
    }
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
.edit-cell {
  cursor: default;
  .span-wrapper {
    width: 100%;
    display: flex;
    .value-span {
      padding-left: 40px;
      background: transparent;
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
      text-overflow: ellipsis;
      padding-right: 24px;
      width: 100%;
      textarea {
        width: 100%;
        height: 100%;
        font-family: "GG", sans-serif;
        border: none;
        color: transparent;
        font-size: 16px;
        text-shadow: 0 0 0 #2c3e50;
        background: transparent;
        padding: 10px 10px 10px 40px;
        cursor: default;
        display: block;
        resize:none;
        position: absolute;
        top: 0px;
      }
    }
  }
  .disabled-row {
    color: rgba(0, 0, 0, 0.2);
  }
  .editing-cell {
    text-align: left;
    color: #2c3e50;
    caret-color: #2c3e50;
    background: white;
    padding-left: 10px;
  }
  .move-module {
    position: absolute;
    left: 10px;
    width: 24px;
    height: 14px;
    object-fit: scale-down;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: none;
  }
  .delete-module {
    cursor: pointer;
    position: absolute;
    right: 10px;
    width: 20px;
    height: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: none;
  }
  .editbox {
    position: absolute;
    top: 40px;
    right: -70px;
  }
  .hidden-icon-wrapper {
    height: 20px;
    width: 20px;
    top: 0;
    position: absolute;
    left: 12px;
    overflow: hidden;
    .hidden-row-above {
      height: 20px;
      width: 20px;
      transform: rotate(90deg);
      cursor: pointer;
      display: block;
      margin-top: -12px;
    }
  }
  .hidden-row-bottom {
    height: 20px;
    width: 20px;
    transform: rotate(90deg);
    cursor: pointer;
    display: block;
    left: 12px;
    bottom: -10px;
    position: absolute;
  }
}
.edit-cell-hover:hover {
  .move-module {
    display: block !important;
  }
  .delete-module {
    display: block !important;
  }
}

.drag-bottom {
  border-bottom: 2px solid rgba(0,0,0,0.5);
}

.drag-top {
  border-top: 2px solid rgba(0,0,0,0.5);
}

</style>
